/**
 * FilterChip - Chip standardizzato per i filtri
 * Cambia colore quando ci sono filtri attivi
 */

import React from 'react';
import { Button, Badge } from '@mui/material';
import { FilterList } from '@mui/icons-material';

interface FilterChipProps {
  onClick: () => void;
  hasActiveFilters: boolean;
  activeFiltersCount?: number;
  label?: string;
  variant?: 'outlined' | 'contained' | 'text';
  size?: 'small' | 'medium' | 'large';
  sx?: object;
}

const FilterChip: React.FC<FilterChipProps> = ({
  onClick,
  hasActiveFilters,
  activeFiltersCount = 0,
  label = 'Filtri',
  variant = 'outlined',
  size = 'medium',
  sx = {}
}) => {
  const getButtonStyles = () => {
    const baseStyles = {
      borderRadius: 2,
      textTransform: 'none' as const,
      fontWeight: 500,
      ...sx
    };

    if (hasActiveFilters) {
      return {
        ...baseStyles,
        backgroundColor: 'primary.main',
        color: 'white',
        borderColor: 'primary.main',
        '&:hover': {
          backgroundColor: 'primary.dark',
          borderColor: 'primary.dark',
        }
      };
    }

    return {
      ...baseStyles,
      backgroundColor: 'transparent',
      color: 'text.primary',
      borderColor: 'divider',
      '&:hover': {
        backgroundColor: 'action.hover',
        borderColor: 'primary.main',
      }
    };
  };

  return (
    <Button
      variant={hasActiveFilters ? 'contained' : variant}
      startIcon={<FilterList />}
      onClick={onClick}
      size={size}
      sx={getButtonStyles()}
    >
      {hasActiveFilters && activeFiltersCount > 0 ? (
        <Badge 
          badgeContent={activeFiltersCount} 
          color="error"
          sx={{
            '& .MuiBadge-badge': {
              right: -8,
              top: -8,
              fontSize: '0.75rem',
              minWidth: '18px',
              height: '18px',
            }
          }}
        >
          {label}
        </Badge>
      ) : (
        label
      )}
    </Button>
  );
};

export default FilterChip;
